<template>
    <div class="scope-written box-shadow-small border-radius" v-if="resData">
        <p class="mt-10 mb-20">
            <router-link to="/written">笔试</router-link>
            >
            <router-link to="/written/exam/list">笔试安排列表</router-link>
            >
            <span>笔试安排详情</span>
        </p>
        <el-form ref="ruleForm" label-width="120px" class="mt-20">
            <el-form-item label="考试标题" prop="title">
                {{resData.exam.title}}
            </el-form-item>
            <el-form-item label="考生须知" prop="examRules">
                {{resData.exam.examRules}}
            </el-form-item>
            <el-form-item label="选择笔试题" prop="paperIds">
                <p v-for="(item, index) in resData.exam.paperList" :key="index"><router-link target="_blank" :to="`/written/topic/${item.id}?resumePositionId=&examId=`">{{item.name}}</router-link></p>
            </el-form-item>
            <el-form-item label="考试日期">
                <p v-for="(item, index) in resData.exam.examTimes" :key="index">{{item.startTime}}-{{item.endTime}}</p>
            </el-form-item>
        </el-form>
        <div class="table-list mt-20">
            <el-table :data="resData.list">
                <el-table-column
                        label="候选人"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="手机号"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.phone }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="职位"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.positionName }}
                    </template>
                </el-table-column>
                <el-table-column
                        label="简历来源"
                        :show-overflow-tooltip="true"
                        align="center"
                        min-width="100">
                    <template slot-scope="scope">
                        {{ getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-'}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="text-center mt-20 mb-20">
            <el-button type="primary" plain="" @click="backToExanmList">关闭</el-button>
        </div>
    </div>
</template>
<script type="text/javascript">
    import { dateFormat } from 'modules/tools'
    import selectMapMixin from 'mixins/selectMapMixin'

    export default {
        'mixins': [selectMapMixin],
        data () {
            return {
                resData: null
            }
        },
        methods: {
            backToExanmList() {
                if (window.history.length <= 1) {
                    this.$router.push({path: '/wb/written/exam/list'})
                    return false
                } else {
                    this.$router.back(-1)
                }
            }
        },
        created () {
            this.$axios.get('/exam/getDetailById.api?id=' + this.$route.params.id).then(res => {
                this.resData = res.result
            }).catch(console.error)
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .scope-written {
        margin  : $padding-width;
        padding : 10px 30px;
        .pick-exam-time {
            .color-gray {
                color : $text-color-third;
            }
            .time-dot {
                .el-form-item__label {
                    color : $text-color-third;
                }
            }
            .end-time-holder {
                display : inline-block;
                width   : 50px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// writtenArrangementDetail.vue?682cc924